import { Component, computed, input, Signal, ViewEncapsulation } from '@angular/core';
import { RegimenClass } from '@cureskin/api-client/src/server-api';
import { SwiperOptions } from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { RebrandedCompleteYourProfileCardComponent } from './rebranded-complete-your-profile-card.component';

@Component({
  selector: 'rebranded-complete-your-profile',
  templateUrl: './rebranded-complete-your-profile.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    rebranded-complete-your-profile .swiper-slide {
      width: auto !important;
    }
  `],
  imports: [SwiperModule, RebrandedCompleteYourProfileCardComponent],
})
export class RebrandedCompleteYourProfileComponent {
  readonly regimenClasses = input<RegimenClass[]>([]);
  readonly gender = input<string>('');

  readonly swiperConfig: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    observer: true,
    observeParents: true,
    resizeObserver: true,
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
  };

  readonly isCarousel: Signal<boolean> = computed((): boolean => this.regimenClasses().length > 1);
}
